<template>
  <div class="containerTable" style="position: relative;">
    <vxe-toolbar
      :id="toolbarId"
      :custom="{ storage: true }"
      export
      :refresh="{ query: RefreshList }"
    >
      <template v-slot:buttons>
        <el-button v-if="makeMoney_search_button" @click="funcFilter()">
          查询
        </el-button>
        <!-- @focus="batchInputDialogVisible = true" -->
        <el-button
          v-if="makeMoney_search_button"
          @click="batchInputDialogVisible = true"
        >
          多运单查询
        </el-button>
        <el-button
          v-if="makeMoney_batchPayment_button && shipment.isPayPermission === 1"
          @click="getSelectEvent()"
        >
          批量打款
        </el-button>
        <el-button v-if="makeMoney_reject_button" @click="getRejectEvent()">
          批量驳回
        </el-button>
        <el-button
          v-if="getLimit('MakeMoney_update_button')"
          @click="updataShipperPaymentResult()"
        >
          更新支付状态
        </el-button>
        <el-button @click="columnSettingVisible = true">列设置</el-button>

        <el-button
          v-if="getLimit('makeMoney_export_button')"
          @click="funcExport()"
        >
          导出
        </el-button>
      </template>
    </vxe-toolbar>
    <div style="position: absolute;top: 15px;right: 107px;">
      到付运费合计:
      <span style="color: red;font-weight: bold;">
        {{ selectedShipmentDeliveryFeePracticalSum || "--" }}
      </span>
      &ensp; &ensp; 到付服务费合计:
      <span style="color: red;font-weight: bold;">
        {{ selectedShipmentServiceFeePracticalSum || "--" }}
      </span>
      &ensp; &ensp;实际承运人到付应收运费合计:
      <span style="color: red;font-weight: bold;">
        {{ selectedShipmentDriverActualCashSum || "--" }}&ensp; &ensp;
      </span>
    </div>
    <vxe-table
      v-if="showTable"
      :key="tableKey"
      ref="xTable"
      border
      resizable
      stripe
      highlight-current-row
      show-footer
      highlight-hover-row
      row-id="id"
      class="mytable-footer"
      height="80%"
      :loading="loading"
      :header-cell-class-name="headerCellClassName"
      :cell-class-name="cellClassName"
      :footer-method="footerMethod"
      :checkbox-config="{ highlight: true }"
      :data="tableData"
      :sort-config="{ remote: true }"
      export-config
      show-overflow
      align="center"
      @sort-change="sortList"
      @checkbox-change="updateSelectedFeeSum"
      @checkbox-all="updateSelectedFeeSum"
    >
      <vxe-table-column type="checkbox" width="60" fixed="left" />
      <vxe-table-column v-if="isSub">
        <vxe-table-column
          field="companyName"
          title="子公司名称"
          min-width="200"
          sortable
          fixed="left"
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.companyName"
            placeholder="请输入子公司名称"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column
        v-for="col in columns"
        v-if="col.visible && (col.isAdmin ? isAdmin : true)"
        :key="col.value"
      >
        <vxe-table-column
          :field="col.value"
          :title="col.name"
          :width="col.minWidth || 200"
          :sortable="
            col.value === 'gmtCreated' ||
              col.value === 'lastLoadingTime' ||
              col.value === 'lastUnloadingTime' ||
              col.value === 'gmtModified'
          "
        >
          <template #default="scope">
            <div class="oeder_num_box">
              <span
                v-if="
                  scope.column.property === 'projectName' ||
                    scope.column.property === 'lineName'
                "
                class="copy_text_span"
                @click="copyText(formatterSwitch(scope))"
                v-html="formatterSwitch(scope)"
              />
              <el-tooltip
                v-else
                class="item"
                effect="dark"
                :content="String(formatterSwitch(scope))"
                placement="top-start"
              >
                <span
                  class="copy_text_cursor"
                  @click="copyText(formatterSwitch(scope))"
                  >{{ formatterSwitch(scope) }}</span
                ></el-tooltip
              >
              <!-- -->
              <!-- <img
                v-if="col.value === 'orderCode' && scope.row.payType == 1"
                class="icon_yu"
                src="@/assets/icon/yu.png"
                alt=""
              /> -->
              <div
                v-if="col.value === 'orderCode' && scope.row.payType == 1"
                class="yu_text"
              >
                预付
              </div>
              <div
                v-if="
                  col.value === 'orderCode' &&
                    (scope.row.appealStatus == 1 ||
                      scope.row.appealStatus == 2 ||
                      scope.row.appealStatus == 4 ||
                      scope.row.appealStatus == 5)
                "
                class="abnormal_text"
              >
                异常
              </div>
            </div>
          </template>
        </vxe-table-column>
        <template v-slot:header>
          <template v-if="col.value === 'isReceiptReturn'">
            <el-select
              v-model="listQuery.isReceiptReturn"
              clearable
              placeholder="请选择"
            >
              <el-option
                v-for="item in receiptOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </template>
          <template v-if="col.value === 'branchCode'">
            <el-select
              v-model="listQuery.branchCode"
              placeholder="请选择"
              clearable
            >
              <el-option
                v-for="item in branchList"
                :key="item.code"
                :label="item.groupName"
                :value="item.code"
              />
            </el-select>
          </template>
          <template v-if="col.value === 'shipmentName'">
            <el-input
              v-model="listQuery.shipmentName"
              placeholder="请输入"
              clearable
            />
          </template>
          <template v-if="col.value === 'orderCode'">
            <el-input
              v-model="listQuery.orderCode"
              placeholder="请输入"
              clearable
            />
          </template>
          <template v-if="col.value === 'sourceOrderNumber'">
            <el-input
              v-model="listQuery.sourceOrderNumber"
              placeholder="请输入"
              clearable
            />
          </template>
          <template v-if="col.value === 'projectName'">
            <el-input
              v-model="listQuery.projectName"
              placeholder="请输入"
              clearable
            />
          </template>
          <template v-if="col.value === 'lineName'">
            <el-input
              v-model="listQuery.lineName"
              placeholder="请输入"
              clearable
            />
          </template>
          <template v-if="col.value === 'driverName'">
            <el-input
              v-model="listQuery.driverName"
              placeholder="请输入"
              clearable
            />
          </template>
          <template v-if="col.value === 'driverPhone'">
            <el-input
              v-model="listQuery.driverPhone"
              placeholder="请输入"
              clearable
            />
          </template>
          <template v-if="col.value === 'vehicleLicense'">
            <el-input
              v-model="listQuery.vehicleLicense"
              placeholder="请输入"
              clearable
            />
          </template>
          <!-- 运单状态 -->
          <template v-if="col.value === 'status'">
            <el-select
              v-model="listQuery.status"
              clearable
              placeholder="请选择"
            >
              <el-option
                v-for="item in statusOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </template>
          <!-- 签收状态 -->
          <template v-if="col.value === 'isUnloadingConfirm'">
            <el-select
              v-model="listQuery.isUnloadingConfirm"
              clearable
              placeholder="请选择"
            >
              <el-option
                v-for="item in uploadingOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </template>
          <!-- TODO: 支付状态 isDriverOrAdmin-->
          <!-- <template v-if="col.value === 'payStatus' && col.isDriverOrAdmin">
            <el-select
              v-model="listQuery.payStatus"
              clearable
              placeholder="请选择"
            >
              <el-option
                v-for="item in payOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </template> -->
          <!-- 支付状态isShipment -->
          <template v-if="col.value === 'payStatus'">
            <el-select
              v-model="listQuery.applyStatus"
              clearable
              placeholder="请选择"
            >
              <el-option
                v-for="item in payShipment"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </template>

          <!--托运人实付运费 -->
          <template v-if="col.value === 'shipmentActualFreight'">
            <el-row>
              <el-col :span="11">
                <el-input
                  v-model="listQuery.shipmentActualFreightStart"
                  type="number"
                  placeholder="下限"
                  clearable
                />
              </el-col>
              <el-col :span="11" :offset="2">
                <el-input
                  v-model="listQuery.shipmentActualFreightEnd"
                  type="number"
                  placeholder="上限"
                  clearable
                />
              </el-col>
            </el-row>
          </template>
          <!-- 托运人合计付款 -->
          <template v-if="col.value === 'shipperDeliveryFee'">
            <el-row>
              <el-col :span="11">
                <el-input
                  v-model="listQuery.shipperDeliveryFeeStart"
                  type="number"
                  placeholder="下限"
                  clearable
                />
              </el-col>
              <el-col :span="11" :offset="2">
                <el-input
                  v-model="listQuery.shipperDeliveryFeehEnd"
                  type="number"
                  placeholder="上限"
                  clearable
                />
              </el-col>
            </el-row>
          </template>
          <!-- 其他费用 -->
          <template v-if="col.value === 'abnormalFee'">
            <el-row>
              <el-col :span="11">
                <el-input
                  v-model="listQuery.abnormalFeeStart"
                  type="number"
                  placeholder="下限"
                  clearable
                />
              </el-col>
              <el-col :span="11" :offset="2">
                <el-input
                  v-model="listQuery.abnormalFeeEnd"
                  type="number"
                  placeholder="上限"
                  clearable
                />
              </el-col>
            </el-row>
          </template>
          <!-- 托运人实付现金 -->
          <template v-if="col.value === 'shipmentActualCash'">
            <el-row>
              <el-col :span="11">
                <el-input
                  v-model="listQuery.shipmentActualCashStart"
                  type="number"
                  placeholder="下限"
                  clearable
                />
              </el-col>
              <el-col :span="11" :offset="2">
                <el-input
                  v-model="listQuery.shipmentActualCashEnd"
                  type="number"
                  placeholder="上限"
                  clearable
                />
              </el-col> </el-row
          ></template>

          <template v-if="col.value === 'isCancel'">
            <el-select
              v-model="listQuery.isCancel"
              clearable
              placeholder="请选择"
            >
              <el-option
                v-for="item in cancelOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </template>
          <template v-if="col.value === 'coalTypeName'">
            <el-input
              v-model="listQuery.coalTypeName"
              placeholder="请输入"
              clearable
            />
          </template>
          <template v-if="col.value === 'weight'">
            <el-row>
              <el-col :span="11">
                <el-input
                  v-model="listQuery.weightStart"
                  type="number"
                  placeholder="下限"
                  clearable
                />
              </el-col>
              <el-col :span="11" :offset="2">
                <el-input
                  v-model="listQuery.weightEnd"
                  type="number"
                  placeholder="上限"
                  clearable
                />
              </el-col>
            </el-row>
          </template>
          <!-- 装货数量 -->
          <template v-if="col.value === 'loadQuantity'">
            <el-row>
              <el-col :span="11">
                <el-input
                  v-model="listQuery.loadQuantityStart"
                  type="number"
                  placeholder="下限"
                  clearable
                />
              </el-col>
              <el-col :span="11" :offset="2">
                <el-input
                  v-model="listQuery.loadQuantityEnd"
                  type="number"
                  placeholder="上限"
                  clearable
                />
              </el-col> </el-row
          ></template>
          <!-- 卸货数量 -->
          <template v-if="col.value === 'unloadQuantity'">
            <el-row>
              <el-col :span="11">
                <el-input
                  v-model="listQuery.unloadQuantityStart"
                  type="number"
                  placeholder="下限"
                  clearable
                />
              </el-col>
              <el-col :span="11" :offset="2">
                <el-input
                  v-model="listQuery.unloadQuantityEnd"
                  type="number"
                  placeholder="上限"
                  clearable
                />
              </el-col>
            </el-row>
          </template>
          <!-- 货物损耗 -->
          <template v-if="col.value === 'wastage'">
            <el-row>
              <el-col :span="11">
                <el-input
                  v-model="listQuery.wastageStart"
                  type="number"
                  placeholder="下限"
                  clearable
                />
              </el-col>
              <el-col :span="11" :offset="2">
                <el-input
                  v-model="listQuery.wastageEnd"
                  type="number"
                  placeholder="上限"
                  clearable
                />
              </el-col> </el-row
          ></template>
          <!-- 结算吨位 -->
          <template v-if="col.value === 'settlementWeight'">
            <el-row>
              <el-col :span="11">
                <el-input
                  v-model="listQuery.settlementWeightStart"
                  type="number"
                  placeholder="下限"
                  clearable
                />
              </el-col>
              <el-col :span="11" :offset="2">
                <el-input
                  v-model="listQuery.settlementWeightEnd"
                  type="number"
                  placeholder="上限"
                  clearable
                />
              </el-col>
            </el-row>
          </template>
          <template v-if="col.value === 'taxFee'">
            <el-row>
              <el-col :span="11">
                <el-input
                  v-model="listQuery.taxFeeStart"
                  type="number"
                  placeholder="下限"
                  clearable
                />
              </el-col>
              <el-col :span="11" :offset="2">
                <el-input
                  v-model="listQuery.taxFeeEnd"
                  type="number"
                  placeholder="上限"
                  clearable
                />
              </el-col>
            </el-row>
          </template>
          <template v-if="col.value === 'taxPayFee'">
            <el-row>
              <el-col :span="11">
                <el-input
                  v-model="listQuery.taxPayFeeStart"
                  type="number"
                  placeholder="下限"
                  clearable
                />
              </el-col>
              <el-col :span="11" :offset="2">
                <el-input
                  v-model="listQuery.taxPayFeeEnd"
                  type="number"
                  placeholder="上限"
                  clearable
                />
              </el-col>
            </el-row>
          </template>
          <template v-if="col.value === 'driverActualCash'">
            <el-row>
              <el-col :span="11">
                <el-input
                  v-model="listQuery.driverActualCashStart"
                  type="number"
                  placeholder="下限"
                  clearable
                />
              </el-col>
              <el-col :span="11" :offset="2">
                <el-input
                  v-model="listQuery.driverActualCashEnd"
                  type="number"
                  placeholder="上限"
                  clearable
                />
              </el-col>
            </el-row>
          </template>
          <template v-if="col.value === 'prePay'">
            <el-row>
              <el-col :span="11">
                <el-input
                  v-model="listQuery.prePayStart"
                  type="number"
                  placeholder="下限"
                  clearable
                />
              </el-col>
              <el-col :span="11" :offset="2">
                <el-input
                  v-model="listQuery.prePayEnd"
                  type="number"
                  placeholder="上限"
                  clearable
                />
              </el-col>
            </el-row>
          </template>

          <!-- <template v-if="col.value === 'shipperDeliveryFee'">
            <el-row>
              <el-col :span="11">
                <el-input
                  v-model="listQuery.shipperDeliveryFeeStart"
                  type="number"
                  placeholder="下限"
                  clearable
                />
              </el-col>
              <el-col :span="11" :offset="2">
                <el-input
                  v-model="listQuery.shipperDeliveryFeePayEnd"
                  type="number"
                  placeholder="上限"
                  clearable
                />
              </el-col>
            </el-row>
          </template> -->

          <!-- <template v-if="col.value === 'shipmentActualCash'">
            <el-row>
              <el-col :span="11">
                <el-input
                  v-model="listQuery.shipmentActualCashStart"
                  type="number"
                  placeholder="下限"
                  clearable
                />
              </el-col>
              <el-col :span="11" :offset="2">
                <el-input
                  v-model="listQuery.shipmentActualCashEnd"
                  type="number"
                  placeholder="上限"
                  clearable
                />
              </el-col>
            </el-row>
          </template> -->

          <template v-if="col.value === 'driftPrice'">
            <el-row>
              <el-col :span="11">
                <el-input
                  v-model="listQuery.driftPriceStart"
                  type="number"
                  placeholder="下限"
                  clearable
                />
              </el-col>
              <el-col :span="11" :offset="2">
                <el-input
                  v-model="listQuery.driftPriceEnd"
                  type="number"
                  placeholder="上限"
                  clearable
                />
              </el-col>
            </el-row>
          </template>

          <!-- 托运人应付运费 -->
          <template v-if="col.value === 'shipmentDeliveryFeePractical'">
            <el-row>
              <el-col :span="11">
                <el-input
                  v-model="listQuery.shipmentDeliveryFeePracticalStart"
                  type="number"
                  placeholder="下限"
                  clearable
                />
              </el-col>
              <el-col :span="11" :offset="2">
                <el-input
                  v-model="listQuery.shipmentDeliveryFeePracticalEnd"
                  type="number"
                  placeholder="上限"
                  clearable
                />
              </el-col>
            </el-row>
          </template>
          <template v-if="col.value === 'deliveryFeeDeserved'">
            <el-row>
              <el-col :span="11">
                <el-input
                  v-model="listQuery.deliveryFeeDeservedStart"
                  type="number"
                  placeholder="下限"
                  clearable
                />
              </el-col>
              <el-col :span="11" :offset="2">
                <el-input
                  v-model="listQuery.deliveryFeeDeservedEnd"
                  type="number"
                  placeholder="上限"
                  clearable
                />
              </el-col>
            </el-row>
          </template>

          <template v-if="col.value === 'placeOfShipment'">
            <el-input
              v-model="listQuery.placeOfShipment"
              placeholder="请输入"
              clearable
            />
          </template>
          <template v-if="col.value === 'placeOfReceipt'">
            <el-input
              v-model="listQuery.placeOfReceipt"
              placeholder="请输入"
              clearable
            />
          </template>

          <template v-if="col.value === 'coalPrice'">
            <el-row>
              <el-col :span="11">
                <el-input
                  v-model="listQuery.coalPriceStart"
                  type="number"
                  placeholder="下限"
                  clearable
                />
              </el-col>
              <el-col :span="11" :offset="2">
                <el-input
                  v-model="listQuery.coalPriceEnd"
                  type="number"
                  placeholder="上限"
                  clearable
                />
              </el-col>
            </el-row>
          </template>

          <template v-if="col.value === 'coalName'">
            <el-input
              v-model="listQuery.coalName"
              placeholder="请输入"
              clearable
            />
          </template>
          <template v-if="col.value === 'allTaxFee'">
            <el-row>
              <el-col :span="11">
                <el-input
                  v-model="listQuery.allTaxFeeStart"
                  type="number"
                  placeholder="下限"
                  clearable
                />
              </el-col>
              <el-col :span="11" :offset="2">
                <el-input
                  v-model="listQuery.allTaxFeeEnd"
                  type="number"
                  placeholder="上限"
                  clearable
                />
              </el-col>
            </el-row>
          </template>

          <template v-if="col.value === 'distance'">
            <el-row>
              <el-col :span="11">
                <el-input
                  v-model="listQuery.distanceStart"
                  type="number"
                  placeholder="下限"
                  clearable
                />
              </el-col>
              <el-col :span="11" :offset="2">
                <el-input
                  v-model="listQuery.distanceEnd"
                  type="number"
                  placeholder="上限"
                  clearable
                />
              </el-col>
            </el-row>
          </template>

          <template v-if="col.value === 'isMonthlyOrder'">
            <el-select
              v-model="listQuery.isMonthlyOrder"
              placeholder="请选择"
              clearable
            >
              <el-option
                v-for="item in parentData.isMonthlyOrderOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </template>

          <template v-if="col.value === 'isTransfer'">
            <el-select
              v-model="listQuery.isTransferSearch"
              clearable
              placeholder="请选择"
            >
              <el-option
                v-for="item in isTransferSearchOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </template>

          <template v-if="col.value === 'gmtCreated'">
            <el-date-picker
              v-model="listQuery.gmtCreatedRange"
              value-format="yyyy-MM-dd"
              type="daterange"
              :picker-options="optionsPicker"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @change="value => changeDate(value, 'gmtCreated')"
            />
          </template>

          <template v-if="col.value === 'lastLoadingTime'">
            <el-date-picker
              v-model="listQuery.lastLoadingTimeRange"
              value-format="yyyy-MM-dd"
              type="daterange"
              :picker-options="optionsPicker"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @change="value => changeDate(value, 'lastLoadingTime')"
            />
          </template>

          <template v-if="col.value === 'lastUnloadingTime'">
            <el-date-picker
              v-model="listQuery.lastUnloadingTimeRange"
              value-format="yyyy-MM-dd"
              type="daterange"
              :picker-options="optionsPicker"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @change="value => changeDate(value, 'lastUnloadingTime')"
            />
          </template>

          <template v-if="col.value === 'mainOrderNumber'">
            <el-input
              v-model="listQuery.mainOrderNumber"
              placeholder="请输入"
              clearable
            />
          </template>

          <template v-if="col.value === 'teamName'">
            <el-input
              v-model="listQuery.teamName"
              placeholder="请输入"
              clearable
            />
          </template>

          <template v-if="col.value === 'companyName'">
            <el-input
              v-model="listQuery.companyName"
              placeholder="请输入"
              clearable
            />
          </template>

          <template v-if="col.value === 'dfName'">
            <el-input
              v-model="listQuery.dfName"
              placeholder="请输入"
              clearable
            />
          </template>

          <template v-if="col.value === 'ordCreatedByPhone'">
            <el-input
              v-model="listQuery.ordCreatedByPhone"
              placeholder="请输入"
              clearable
            />
          </template>

          <template v-if="col.value === 'shipmentStaffTypeStr'">
            <el-select
              v-model="listQuery.shipmentStaffType"
              clearable
              placeholder="请选择"
            >
              <el-option
                v-for="item in shipmentOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </template>

          <template v-if="col.value === 'gmtModified'">
            <el-date-picker
              v-model="listQuery.gmtModifiedRange"
              value-format="yyyy-MM-dd"
              type="daterange"
              :picker-options="optionsPicker"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @change="value => changeDate(value, 'gmtModified')"
            />
          </template>

          <template v-if="col.value === 'modifiedByName'">
            <el-input
              v-model="listQuery.modifiedByName"
              placeholder="请输入"
              clearable
            />
          </template>
          <template v-if="col.value === 'deliveryFeePractical'">
            <el-row>
              <el-col :span="11">
                <el-input
                  v-model="listQuery.deliveryFeePracticalStart"
                  type="number"
                  placeholder="下限"
                  clearable
                />
              </el-col>
              <el-col :span="11" :offset="2">
                <el-input
                  v-model="listQuery.deliveryFeePracticalEnd"
                  type="number"
                  placeholder="上限"
                  clearable
                />
              </el-col> </el-row
          ></template>
          <template v-if="col.value === 'loadPlace'">
            <el-input
              v-model="listQuery.loadPlace"
              placeholder="请输入实际操作装货地址"
              clearable
            />
          </template>
          <template v-if="col.value === 'unloadPlace'">
            <el-input
              v-model="listQuery.unloadPlace"
              placeholder="请输入实际操作卸货地址"
              clearable
          /></template>
          <template v-if="col.value === 'reportMark'">
            <el-select
              v-model="listQuery.reportMark"
              clearable
              placeholder="请选择"
            >
              <el-option
                v-for="item in isTransferSearchOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              /> </el-select
          ></template>
          <!-- 装车时间 -->
          <template v-if="col.value === 'fillTime'">
            <el-date-picker
              v-model="listQuery.fillTimeRange"
              value-format="yyyy-MM-dd"
              type="daterange"
              :picker-options="optionsPicker"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @change="value => changeDate(value, 'fillTime')"
            />
          </template>
          <!-- 卸车时间 -->
          <template v-if="col.value === 'signTime'">
            <el-date-picker
              v-model="listQuery.signTimeRange"
              value-format="yyyy-MM-dd"
              type="daterange"
              :picker-options="optionsPicker"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @change="value => changeDate(value, 'signTime')"
            />
          </template>
          <!-- 核算时间 -->
          <template v-if="col.value === 'settleTime'">
            <el-date-picker
              v-model="listQuery.settleTimeRange"
              value-format="yyyy-MM-dd"
              type="daterange"
              :picker-options="optionsPicker"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @change="value => changeDate(value, 'settleTime')"
            />
          </template>
          <template v-if="col.value === 'shipmentPayFailReasons'">
            <el-input
              v-model="listQuery.shipmentPayFailReasons"
              placeholder="请输入失败原因"
              clearable
            />
          </template>
          <template v-if="col.value === 'shipmentPayStatus'">
            <el-select
              v-model="listQuery.shipmentPayStatus"
              clearable
              placeholder="请选择"
            >
              <el-option
                v-for="item in payShipment"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </template>
          <template v-if="col.value === 'taxPrice'">
            <el-row>
              <el-col :span="11">
                <el-input
                  v-model="listQuery.taxPriceStart"
                  type="number"
                  placeholder="下限"
                  clearable
                />
              </el-col>
              <el-col :span="11" :offset="2">
                <el-input
                  v-model="listQuery.taxPriceEnd"
                  type="number"
                  placeholder="上限"
                  clearable
                />
              </el-col>
            </el-row>
          </template>
          <template v-if="col.value === 'maxPrice'">
            <el-row>
              <el-col :span="11">
                <el-input
                  v-model="listQuery.maxPriceStart"
                  type="number"
                  placeholder="下限"
                  clearable
                />
              </el-col>
              <el-col :span="11" :offset="2">
                <el-input
                  v-model="listQuery.maxPriceEnd"
                  type="number"
                  placeholder="上限"
                  clearable
                />
              </el-col>
            </el-row>
          </template>
          <template v-if="col.value === 'realPrice'">
            <el-row>
              <el-col :span="11">
                <el-input
                  v-model="listQuery.realPriceStart"
                  type="number"
                  placeholder="下限"
                  clearable
                />
              </el-col>
              <el-col :span="11" :offset="2">
                <el-input
                  v-model="listQuery.realPriceEnd"
                  type="number"
                  placeholder="上限"
                  clearable
                />
              </el-col>
            </el-row>
          </template>
          <template v-if="col.value === 'deliveryCashFee'">
            <el-row>
              <el-col :span="11">
                <el-input
                  v-model="listQuery.deliveryCashFeeStart"
                  type="number"
                  placeholder="下限"
                  clearable
                />
              </el-col>
              <el-col :span="11" :offset="2">
                <el-input
                  v-model="listQuery.deliveryCashFeeEnd"
                  type="number"
                  placeholder="上限"
                  clearable
                />
              </el-col>
            </el-row>
          </template>
          <template v-if="col.value === 'extraFee'">
            <el-row>
              <el-col :span="11">
                <el-input
                  v-model="listQuery.extraFeeStart"
                  type="number"
                  placeholder="下限"
                  clearable
                />
              </el-col>
              <el-col :span="11" :offset="2">
                <el-input
                  v-model="listQuery.extraFeeEnd"
                  type="number"
                  placeholder="上限"
                  clearable
                />
              </el-col>
            </el-row>
          </template>
        </template>
      </vxe-table-column>
      <template v-if="false">
        <vxe-table-column>
          <vxe-table-column
            field="branchCode"
            title="承运主体"
            :formatter="formatterBranch"
            min-width="150"
            sortable
          />
          <template v-slot:header>
            <el-select
              v-model="listQuery.branchCode"
              placeholder="请选择"
              clearable
            >
              <el-option
                v-for="item in branchList"
                :key="item.code"
                :label="item.groupName"
                :value="item.code"
              />
            </el-select>
          </template>
        </vxe-table-column>
        <vxe-table-column v-if="isShipmentOrAdmin">
          <vxe-table-column
            field="isReceiptReturn"
            :formatter="formatterReceiptStatus"
            title="纸质回单状态"
            min-width="150"
            sortable
          />
          <template v-slot:header>
            <el-select
              v-model="listQuery.isReceiptReturn"
              clearable
              placeholder="请选择"
            >
              <el-option
                v-for="item in receiptOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            field="orderCode"
            title="运输单号"
            min-width="250"
            sortable
          >
            <template #default="scope">
              <div class="oeder_num_box">
                {{ scope.row.orderCode }}
                <!-- -->
                <img
                  v-if="scope.row.payType == 1"
                  class="icon_yu"
                  src="@/assets/icon/yu.png"
                  alt=""
                />
              </div>
            </template>
          </vxe-table-column>
          <template v-slot:header>
            <el-input
              v-model="listQuery.orderCode"
              placeholder="请输入运输单号"
              clearable
            />
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            field="mainOrderNumber"
            title="货源单号"
            min-width="250"
            sortable
          />
          <template v-slot:header>
            <el-input
              v-model="listQuery.mainOrderNumber"
              placeholder="请输入货源单号"
              clearable
            />
          </template>
        </vxe-table-column>
        <!-- 项目信息 -->
        <vxe-table-column>
          <vxe-table-column
            field="sourceOrderNumber"
            title="来源单号"
            min-width="200"
            sortable
          />
          <template v-slot:header>
            <el-input
              v-model="listQuery.sourceOrderNumber"
              placeholder="请输入来源单号"
              clearable
            />
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            field="projectName"
            title="项目名称"
            min-width="200"
            sortable
          />
          <template v-slot:header>
            <el-input
              v-model="listQuery.projectName"
              placeholder="请输入项目名称"
              clearable
            />
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            field="lineName"
            title="线路简称"
            min-width="200"
            sortable
          />
          <template v-slot:header>
            <el-input
              v-model="listQuery.lineName"
              placeholder="请输入线路简称"
              clearable
            />
          </template>
        </vxe-table-column>
        <vxe-table-column v-if="isShipmentOrAdmin">
          <vxe-table-column
            field="dfName"
            title="经办人"
            min-width="130"
            sortable
          />
          <template v-slot:header>
            <el-input
              v-model="listQuery.dfName"
              placeholder="请输入经办人"
              clearable
            />
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            field="shipmentName"
            title="托运人名称"
            min-width="160"
            sortable
          />
          <template v-slot:header>
            <el-input
              v-model="listQuery.shipmentName"
              placeholder="请输入托运人名称"
              clearable
            />
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            field="ordCreatedByPhone"
            title="托运人电话"
            min-width="160"
            sortable
          />
          <template v-slot:header>
            <el-input
              v-model="listQuery.ordCreatedByPhone"
              placeholder="请输入托运人电话"
              clearable
            />
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            field="shipmentStaffTypeStr"
            title="托运人类型"
            min-width="160"
            sortable
          />
          <template v-slot:header>
            <el-select
              v-model="listQuery.shipmentStaffType"
              clearable
              placeholder="请选择"
            >
              <el-option
                v-for="item in shipmentOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            field="companyName"
            title="托运人"
            min-width="160"
            sortable
          />
          <template v-slot:header>
            <el-input
              v-model="listQuery.companyName"
              placeholder="请输入托运人"
              clearable
            />
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            field="isMonthlyOrder"
            title="结算类型"
            min-width="100"
            :formatter="
              ({ cellValue }) => formatterField({ cellValue }, 'isMonthlyOrder')
            "
            sortable
          />
          <template v-slot:header>
            <el-select
              v-model="listQuery.isMonthlyOrder"
              placeholder="请选择"
              clearable
            >
              <el-option
                v-for="item in parentData.isMonthlyOrderOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            field="shipmentPayStatus"
            title="支付状态"
            :formatter="formatterApplyStatus"
            min-width="200"
            sortable
          />
          <template v-slot:header>
            <el-select
              v-model="listQuery.shipmentPayStatus"
              clearable
              placeholder="请选择"
            >
              <el-option
                v-for="item in payShipment"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </template>
        </vxe-table-column>
        <vxe-table-column v-if="isShipmentOrAdmin">
          <vxe-table-column
            field="shipmentPayFailReasons"
            title="失败原因"
            min-width="200"
            sortable
          />
          <template v-slot:header>
            <el-input
              v-model="listQuery.shipmentPayFailReasons"
              placeholder="请输入失败原因"
              clearable
            />
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            field="coalTypeName"
            title="货物名称"
            min-width="130"
            sortable
          />
          <template v-slot:header>
            <el-input
              v-model="listQuery.coalTypeName"
              placeholder="请输入货物名称"
              clearable
            />
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            field="coalPrice"
            title="货物单价"
            min-width="200"
            sortable
          />
          <template v-slot:header>
            <el-row>
              <el-col :span="11">
                <el-input
                  v-model="listQuery.coalPriceStart"
                  type="number"
                  placeholder="下限"
                  clearable
                />
              </el-col>
              <el-col :span="11" :offset="2">
                <el-input
                  v-model="listQuery.coalPriceEnd"
                  type="number"
                  placeholder="上限"
                  clearable
                />
              </el-col>
            </el-row>
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            field="coalName"
            title="运输要求"
            min-width="130"
            sortable
          />
          <template v-slot:header>
            <el-input
              v-model="listQuery.coalName"
              placeholder="请输入运输要求"
              clearable
            />
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            field="placeOfShipment"
            title="装货地址"
            min-width="450"
            sortable
          />
          <template v-slot:header>
            <el-input
              v-model="listQuery.placeOfShipment"
              placeholder="请输入装货地址"
              clearable
            />
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            field="loadPlace"
            title="实际操作装货地址"
            min-width="450"
            sortable
          />
          <template v-slot:header>
            <el-input
              v-model="listQuery.loadPlace"
              placeholder="请输入实际操作装货地址"
              clearable
            />
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            field="placeOfReceipt"
            title="卸货地址"
            min-width="450"
            sortable
          />
          <template v-slot:header>
            <el-input
              v-model="listQuery.placeOfReceipt"
              placeholder="请输入卸货地址"
              clearable
            />
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            field="unloadPlace"
            title="实际操作卸货地址"
            min-width="450"
            sortable
          />
          <template v-slot:header>
            <el-input
              v-model="listQuery.unloadPlace"
              placeholder="请输入实际操作卸货地址"
              clearable
            />
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            field="distance"
            title="里程数(公里)"
            min-width="200"
            sortable
          />
          <template v-slot:header>
            <el-row>
              <el-col :span="11">
                <el-input
                  v-model="listQuery.distanceStart"
                  type="number"
                  placeholder="下限"
                  clearable
                />
              </el-col>
              <el-col :span="11" :offset="2">
                <el-input
                  v-model="listQuery.distanceEnd"
                  type="number"
                  placeholder="上限"
                  clearable
                />
              </el-col>
            </el-row>
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            field="teamName"
            title="车队名称"
            min-width="200"
            sortable
          />
          <template v-slot:header>
            <el-input
              v-model="listQuery.teamName"
              placeholder="请输入车队名称"
              clearable
            />
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            field="driverName"
            title="实际承运人姓名"
            min-width="130"
            sortable
          />
          <template v-slot:header>
            <el-input
              v-model="listQuery.driverName"
              placeholder="请输入实际承运人姓名"
              clearable
            />
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            field="driverPhone"
            title="实际承运人电话"
            min-width="130"
            sortable
          />
          <template v-slot:header>
            <el-input
              v-model="listQuery.driverPhone"
              placeholder="请输入实际承运人电话"
              clearable
            />
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            field="vehicleLicense"
            title="车牌号"
            min-width="130"
            sortable
          />
          <template v-slot:header>
            <el-input
              v-model="listQuery.vehicleLicense"
              placeholder="请输入车牌号"
              clearable
            />
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            field="weight"
            title="接单数量"
            min-width="200"
            sortable
          />
          <template v-slot:header>
            <el-row>
              <el-col :span="11">
                <el-input
                  v-model="listQuery.weightStart"
                  type="number"
                  placeholder="下限"
                  clearable
                />
              </el-col>
              <el-col :span="11" :offset="2">
                <el-input
                  v-model="listQuery.weightEnd"
                  type="number"
                  placeholder="上限"
                  clearable
                />
              </el-col>
            </el-row>
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            field="loadQuantity"
            title="装货数量"
            min-width="200"
            sortable
          />
          <template v-slot:header>
            <el-row>
              <el-col :span="11">
                <el-input
                  v-model="listQuery.loadQuantityStart"
                  type="number"
                  placeholder="下限"
                  clearable
                />
              </el-col>
              <el-col :span="11" :offset="2">
                <el-input
                  v-model="listQuery.loadQuantityEnd"
                  type="number"
                  placeholder="上限"
                  clearable
                />
              </el-col>
            </el-row>
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            field="unloadQuantity"
            title="卸货数量"
            min-width="200"
            sortable
          />
          <template v-slot:header>
            <el-row>
              <el-col :span="11">
                <el-input
                  v-model="listQuery.unloadQuantityStart"
                  type="number"
                  placeholder="下限"
                  clearable
                />
              </el-col>
              <el-col :span="11" :offset="2">
                <el-input
                  v-model="listQuery.unloadQuantityEnd"
                  type="number"
                  placeholder="上限"
                  clearable
                />
              </el-col>
            </el-row>
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            field="wastage"
            title="货物损耗"
            min-width="200"
            sortable
          />
          <template v-slot:header>
            <el-row>
              <el-col :span="11">
                <el-input
                  v-model="listQuery.wastageStart"
                  type="number"
                  placeholder="下限"
                  clearable
                />
              </el-col>
              <el-col :span="11" :offset="2">
                <el-input
                  v-model="listQuery.wastageEnd"
                  type="number"
                  placeholder="上限"
                  clearable
                />
              </el-col>
            </el-row>
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            field="settlementWeight"
            title="结算吨位"
            min-width="200"
            sortable
          />
          <template v-slot:header>
            <el-row>
              <el-col :span="11">
                <el-input
                  v-model="listQuery.settlementWeightStart"
                  type="number"
                  placeholder="下限"
                  clearable
                />
              </el-col>
              <el-col :span="11" :offset="2">
                <el-input
                  v-model="listQuery.settlementWeightEnd"
                  type="number"
                  placeholder="上限"
                  clearable
                />
              </el-col>
            </el-row>
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            field="maxPrice"
            title="最高价"
            min-width="200"
            sortable
          />
          <template v-slot:header>
            <el-row>
              <el-col :span="11">
                <el-input
                  v-model="listQuery.maxPriceStart"
                  type="number"
                  placeholder="下限"
                  clearable
                />
              </el-col>
              <el-col :span="11" :offset="2">
                <el-input
                  v-model="listQuery.maxPriceEnd"
                  type="number"
                  placeholder="上限"
                  clearable
                />
              </el-col>
            </el-row>
          </template>
        </vxe-table-column>
        <vxe-table-column v-if="isShipmentOrAdmin">
          <vxe-table-column
            field="taxPrice"
            title="托运人成交单价"
            min-width="200"
            sortable
          />
          <template v-slot:header>
            <el-row>
              <el-col :span="11">
                <el-input
                  v-model="listQuery.taxPriceStart"
                  type="number"
                  placeholder="下限"
                  clearable
                />
              </el-col>
              <el-col :span="11" :offset="2">
                <el-input
                  v-model="listQuery.taxPriceEnd"
                  type="number"
                  placeholder="上限"
                  clearable
                />
              </el-col>
            </el-row>
          </template>
        </vxe-table-column>
        <vxe-table-column v-if="isShipmentOrAdmin">
          <vxe-table-column
            field="taxFee"
            title="托运人预估运费(元)"
            min-width="200"
            sortable
          />
          <template v-slot:header>
            <el-row>
              <el-col :span="11">
                <el-input
                  v-model="listQuery.taxFeeStart"
                  type="number"
                  placeholder="下限"
                  clearable
                />
              </el-col>
              <el-col :span="11" :offset="2">
                <el-input
                  v-model="listQuery.taxFeeEnd"
                  type="number"
                  placeholder="上限"
                  clearable
                />
              </el-col>
            </el-row>
          </template>
        </vxe-table-column>
        <!-- <vxe-table-column v-if="isShipmentOrAdmin">
        <vxe-table-column
          field="payAmount"
          title="托运人预付运费(元)"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.payTaxAmountStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.payTaxAmountEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column> -->
        <!-- TODO: -->
        <vxe-table-column>
          <vxe-table-column
            field="shipperDeliveryFee"
            title="到付款费(元)"
            min-width="200"
            sortable
          />
          <template v-slot:header>
            <el-row>
              <el-col :span="11">
                <el-input
                  v-model="listQuery.shipperDeliveryFeeStart"
                  type="number"
                  placeholder="下限"
                  clearable
                />
              </el-col>
              <el-col :span="11" :offset="2">
                <el-input
                  v-model="listQuery.shipperDeliveryFeeEnd"
                  type="number"
                  placeholder="上限"
                  clearable
                />
              </el-col>
            </el-row>
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            field="taxPayFee"
            title="到付款服务费(元)"
            min-width="200"
            sortable
          />
          <template v-slot:header>
            <el-row>
              <el-col :span="11">
                <el-input
                  v-model="listQuery.taxPayFeeStart"
                  type="number"
                  placeholder="下限"
                  clearable
                />
              </el-col>
              <el-col :span="11" :offset="2">
                <el-input
                  v-model="listQuery.taxPayFeeEnd"
                  type="number"
                  placeholder="上限"
                  clearable
                />
              </el-col>
            </el-row>
          </template>
        </vxe-table-column>

        <!-- <vxe-table-column>
        <vxe-table-column
          field="shipmentActualCash"
          title="回单付款费(元)"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.shipmentActualCashStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.shipmentActualCashEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column> -->
        <!-- <vxe-table-column>
        <vxe-table-column
          field="returnTaxFee"
          title="回单付款服务费(元)"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.returnTaxFeeStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.returnTaxFeeEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column> -->
        <!-- <vxe-table-column>
        <vxe-table-column
          field="allTaxFee"
          title="总服务费(元)"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.allTaxFeeStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.allTaxFeeEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column> -->
        <!-- end -->
        <vxe-table-column v-if="isShipmentOrAdmin">
          <vxe-table-column
            field="shipmentDeliveryFeePractical"
            title="托运人应付运费(元)"
            min-width="200"
            sortable
          />
          <template v-slot:header>
            <el-row>
              <el-col :span="11">
                <el-input
                  v-model="listQuery.shipmentDeliveryFeePracticalStart"
                  type="number"
                  placeholder="下限"
                  clearable
                />
              </el-col>
              <el-col :span="11" :offset="2">
                <el-input
                  v-model="listQuery.shipmentDeliveryFeePracticalEnd"
                  type="number"
                  placeholder="上限"
                  clearable
                />
              </el-col>
            </el-row>
          </template>
        </vxe-table-column>
        <!-- <vxe-table-column v-if="isShipmentOrAdmin">
        <vxe-table-column
          field="shipmentActualFreight"
          title="托运人实付运费(元)"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.shipmentActualFreightStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.shipmentActualFreightEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column> -->
        <!-- <vxe-table-column v-if="isShipmentOrAdmin">
        <vxe-table-column
          field="shipmentActualCash"
          title="托运人实付现金(元)"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.shipmentActualCashStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.shipmentActualCashEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column> -->
        <!-- <vxe-table-column v-if="isShipmentOrAdmin">
        <vxe-table-column
          field="shipperDeliveryFee"
          title="托运人合计付款(元)"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.shipperDeliveryFeeStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.shipperDeliveryFeeEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column> -->
        <!-- 实际承运人应收运费  -->
        <vxe-table-column>
          <vxe-table-column
            field="driverActualCash"
            title="实际承运人到付应收运费"
            min-width="200"
            sortable
          />
          <template v-slot:header>
            <el-row>
              <el-col :span="11">
                <el-input
                  v-model="listQuery.driverActualCashStart"
                  type="number"
                  placeholder="下限"
                  clearable
                />
              </el-col>
              <el-col :span="11" :offset="2">
                <el-input
                  v-model="listQuery.driverActualCashEnd"
                  type="number"
                  placeholder="上限"
                  clearable
                />
              </el-col>
            </el-row>
          </template>
        </vxe-table-column>
        <!-- <vxe-table-column v-if="false">
        <vxe-table-column
          field="taxPayFee"
          title="服务费(元)"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.taxPayFeeStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.taxPayFeeEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column> -->
        <vxe-table-column v-if="isDriverOrAdmin">
          <vxe-table-column
            field="realPrice"
            title="实际承运人承运单价"
            min-width="200"
            sortable
          />
          <template v-slot:header>
            <el-row>
              <el-col :span="11">
                <el-input
                  v-model="listQuery.realPriceStart"
                  type="number"
                  placeholder="下限"
                  clearable
                />
              </el-col>
              <el-col :span="11" :offset="2">
                <el-input
                  v-model="listQuery.realPriceEnd"
                  type="number"
                  placeholder="上限"
                  clearable
                />
              </el-col>
            </el-row>
          </template>
        </vxe-table-column>
        <vxe-table-column v-if="isDriverOrAdmin">
          <vxe-table-column
            field="deliveryFeeDeserved"
            title="实际承运人预估运费(元)"
            min-width="200"
            sortable
          />
          <template v-slot:header>
            <el-row>
              <el-col :span="11">
                <el-input
                  v-model="listQuery.deliveryFeeDeservedStart"
                  type="number"
                  placeholder="下限"
                  clearable
                />
              </el-col>
              <el-col :span="11" :offset="2">
                <el-input
                  v-model="listQuery.deliveryFeeDeservedEnd"
                  type="number"
                  placeholder="上限"
                  clearable
                />
              </el-col>
            </el-row>
          </template>
        </vxe-table-column>
        <!-- <vxe-table-column v-if="isDriverOrAdmin">
        <vxe-table-column
          field="platformPrepayment"
          title="平台预付运费(元)"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.platformPrepaymentStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.platformPrepaymentEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column> -->
        <vxe-table-column v-if="isDriverOrAdmin">
          <vxe-table-column
            field="deliveryFeePractical"
            title="实际承运人应收运费(元)"
            min-width="200"
            sortable
          />
          <template v-slot:header>
            <el-row>
              <el-col :span="11">
                <el-input
                  v-model="listQuery.deliveryFeePracticalStart"
                  type="number"
                  placeholder="下限"
                  clearable
                />
              </el-col>
              <el-col :span="11" :offset="2">
                <el-input
                  v-model="listQuery.deliveryFeePracticalEnd"
                  type="number"
                  placeholder="上限"
                  clearable
                />
              </el-col>
            </el-row>
          </template>
        </vxe-table-column>
        <!-- <vxe-table-column v-if="isDriverOrAdmin">
        <vxe-table-column
          field="driverActualFreight"
          title="实际承运人实收运费(元)"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.driverActualFreightStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.driverActualFreightEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column> -->
        <!-- <vxe-table-column v-if="isDriverOrAdmin">
        <vxe-table-column
          field="driverActualCash"
          title="实际承运人实收现金(元)"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.driverActualCashStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.driverActualCashEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column> -->
        <vxe-table-column v-if="isDriverOrAdmin">
          <vxe-table-column
            field="deliveryCashFee"
            title="实际承运人合计收款(元)"
            min-width="200"
            sortable
          />
          <template v-slot:header>
            <el-row>
              <el-col :span="11">
                <el-input
                  v-model="listQuery.deliveryCashFeeStart"
                  type="number"
                  placeholder="下限"
                  clearable
                />
              </el-col>
              <el-col :span="11" :offset="2">
                <el-input
                  v-model="listQuery.deliveryCashFeeEnd"
                  type="number"
                  placeholder="上限"
                  clearable
                />
              </el-col>
            </el-row>
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            field="extraFee"
            title="其他费用(元)"
            min-width="200"
            sortable
          />
          <template v-slot:header>
            <el-row>
              <el-col :span="11">
                <el-input
                  v-model="listQuery.extraFeeStart"
                  type="number"
                  placeholder="下限"
                  clearable
                />
              </el-col>
              <el-col :span="11" :offset="2">
                <el-input
                  v-model="listQuery.extraFeeEnd"
                  type="number"
                  placeholder="上限"
                  clearable
                />
              </el-col>
            </el-row>
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            field="abnormalFee"
            title="异常费用(元)"
            min-width="200"
            sortable
          />
          <template v-slot:header>
            <el-row>
              <el-col :span="11">
                <el-input
                  v-model="listQuery.abnormalFeeStart"
                  type="number"
                  placeholder="下限"
                  clearable
                />
              </el-col>
              <el-col :span="11" :offset="2">
                <el-input
                  v-model="listQuery.abnormalFeeEnd"
                  type="number"
                  placeholder="上限"
                  clearable
                />
              </el-col>
            </el-row>
          </template>
        </vxe-table-column>
        <!-- <vxe-table-column v-if="isAdmin">
        <vxe-table-column field="payOil" title="平台预付油点(元)" min-width="200" sortable />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input v-model="listQuery.payOilStart" type="number" placeholder="下限" clearable />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input v-model="listQuery.payOilEnd" type="number" placeholder="上限" clearable />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column> -->
        <!-- <vxe-table-column v-if="isAdmin">
        <vxe-table-column
          field="payAmount"
          title="平台预付现金(元)"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.payAmountStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.payAmountEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column> -->
        <!-- <vxe-table-column v-if="isDriverOrAdmin">
        <vxe-table-column field="allotOil" title="已分配油费(元)" min-width="200" sortable />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input v-model="listQuery.allotOilStart" type="number" placeholder="下限" clearable />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input v-model="listQuery.allotOilEnd" type="number" placeholder="上限" clearable />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column> -->
        <vxe-table-column>
          <vxe-table-column
            field="gmtCreated"
            title="接单时间"
            min-width="420"
            sortable
          />
          <template v-slot:header>
            <el-date-picker
              v-model="listQuery.gmtCreatedRange"
              value-format="yyyy-MM-dd"
              type="daterange"
              :picker-options="optionsPicker"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @change="value => changeDate(value, 'gmtCreated')"
            />
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            field="lastLoadingTime"
            title="截止装车时间"
            min-width="420"
            sortable
          />
          <template v-slot:header>
            <el-date-picker
              v-model="listQuery.lastLoadingTimeRange"
              value-format="yyyy-MM-dd"
              type="daterange"
              :picker-options="optionsPicker"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @change="value => changeDate(value, 'lastLoadingTime')"
            />
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            field="fillTime"
            title="装车时间"
            min-width="420"
            sortable
          />
          <template v-slot:header>
            <el-date-picker
              v-model="listQuery.fillTimeRange"
              value-format="yyyy-MM-dd"
              type="daterange"
              :picker-options="optionsPicker"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @change="value => changeDate(value, 'fillTime')"
            />
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            field="lastUnloadingTime"
            title="截止卸车时间"
            min-width="420"
            sortable
          />
          <template v-slot:header>
            <el-date-picker
              v-model="listQuery.lastUnloadingTimeRange"
              value-format="yyyy-MM-dd"
              type="daterange"
              :picker-options="optionsPicker"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @change="value => changeDate(value, 'lastUnloadingTime')"
            />
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            field="signTime"
            title="卸车时间"
            min-width="420"
            sortable
          />
          <template v-slot:header>
            <el-date-picker
              v-model="listQuery.signTimeRange"
              value-format="yyyy-MM-dd"
              type="daterange"
              :picker-options="optionsPicker"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @change="value => changeDate(value, 'signTime')"
            />
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            field="settleTime"
            title="核算时间"
            min-width="420"
            sortable
          />
          <template v-slot:header>
            <el-date-picker
              v-model="listQuery.settleTimeRange"
              value-format="yyyy-MM-dd"
              type="daterange"
              :picker-options="optionsPicker"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @change="value => changeDate(value, 'settleTime')"
            />
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            field="gmtModified"
            title="最后操作时间"
            min-width="420"
            sortable
          />
          <template v-slot:header>
            <el-date-picker
              v-model="listQuery.gmtModifiedRange"
              value-format="yyyy-MM-dd"
              type="daterange"
              :picker-options="optionsPicker"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @change="value => changeDate(value, 'gmtModified')"
            />
          </template>
        </vxe-table-column>
        <vxe-table-column v-if="isAdmin">
          <vxe-table-column
            field="modifiedByName"
            title="最后操作人"
            min-width="130"
            sortable
          />
          <template v-slot:header>
            <el-input
              v-model="listQuery.modifiedByName"
              placeholder="最后操作人"
              clearable
            />
          </template>
        </vxe-table-column>
      </template>

      <vxe-table-column title="操作" width="200" fixed="right">
        <template slot-scope="scope">
          <el-tooltip
            v-if="makeMoney_detail_button"
            class="item"
            effect="dark"
            content="详情"
            placement="top"
          >
            <vxe-button type="text" @click="handleClick(scope.row.code)">
              <i class="el-icon-document" />
            </vxe-button>
          </el-tooltip>
          <!-- <div>{{ shipment.staffType }} {{ isSub }}</div> -->
          <el-tooltip
            v-if="
              makeMoney_reject_button &&
                ((shipment.staffType !== 10 && isSub) || !isSub)
            "
            class="item"
            effect="dark"
            content="驳回"
            placement="top"
          >
            <vxe-button type="text" @click="funcReject(scope.row.code)">
              <i class="el-icon-back" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="
              makeMoney_payment_button &&
                shipment.isPayPermission === 1 &&
                ((shipment.staffType !== 10 && isSub) || !isSub)
            "
            class="item"
            effect="dark"
            content="打款"
            placement="top"
          >
            <vxe-button
              type="text"
              @click="
                businessClick(
                  scope.row.code,
                  scope.row.paymentType,
                  scope.row.ordCreatedByPhone
                )
              "
            >
              <i class="el-icon-coin" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="MakeMoney_update_button && scope.row.shipmentPayStatus == 1"
            class="item"
            effect="dark"
            content="更新支付状态"
            placement="top"
          >
            <vxe-button
              type="text"
              @click="updataShipperPaymentResult(scope.row)"
            >
              <i class="el-icon-refresh" />
            </vxe-button>
          </el-tooltip>
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :page-sizes="Pagingconf"
      :current-page.sync="listQuery.pageNum"
      :page-size.sync="listQuery.pageSize"
      :total="listQuery.total"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total'
      ]"
      @page-change="handlePageChange"
    />
    <vxe-modal
      v-model="details"
      title="查看订单详情"
      width="1000"
      height="600"
      resize
    >
      <accounting ref="detailRef" @openMap="positionFunc" />
    </vxe-modal>
    <vxe-modal
      v-model="positionFlag"
      title="运单轨迹"
      width="88%"
      height="96%"
      resize
      remember
      @close="closePositionFunc"
    >
      <Position
        :key="timer"
        ref="positionRef"
        :order-code="code4OrderTrack"
        :positoin-info="positoinInfo"
        @fatherSubmitMethod="fatherSubmitFunc"
        @fatherCancelMethod="fatherCancelFunc"
      />
    </vxe-modal>
    <vxe-modal v-model="actionFlag" title="打款确认" width="600" resize>
      <paymentAction
        v-if="actionFlag"
        ref="actionRef"
        @closeWindows="receive"
        @error="actionFlag = false"
      />
    </vxe-modal>
    <downloadData ref="downloadRef" />
    <!-- 支付密码输入 -->
    <!-- <vxe-modal v-model="showPay" title="支付" width="400" height="360" resize>
      <payPassword @complete="completePsw"></payPassword>
    </vxe-modal> -->
    <el-dialog title="提示" :visible.sync="dialogVisiblePre" width="30%">
      <h3>以下运单存在未预付,请先支付预付款费</h3>
      <span>{{ prelist }} </span>
      <div style="width:100%;text-align:right;margin-top:30px;">
        <el-button type="primary" @click="copyPre">复制运单号</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="批量输入运单号"
      :visible.sync="batchInputDialogVisible"
      width="650px"
      height="900px"
      class="batch-input-dialog"
    >
      <BatchWaybill
        :codes="listQuery.orderCode"
        @confirmBatchInput="confirmBatchInput"
      />
    </el-dialog>
    <el-dialog
      title="列设置"
      :visible.sync="columnSettingVisible"
      width="480px"
      custom-class="column-setting-dialog"
    >
      <ColumnDrag :columns="columns" @update="applyColumnSettings" />
    </el-dialog>
  </div>
</template>
<script>
import ColumnDrag from "@/components/ColumnDrag.vue";
import BatchWaybill from "@/components/BatchWaybill";
import payPassword from "./components/payPassword";
import {
  orderDetailListAll,
  querySubList,
  financeReject
} from "@/api/transport";
import {
  shipperPaymentSure,
  queryShipperPaymentResult
} from "@/api/InternetBanking";
import accounting from "@/components/WaybillDetails";
import paymentAction from "./components/paymentAction";
import request from "@/utils/request";
import { getLimit } from "@/utils/getLimit.js";
import Position from "@/views/tms/transportManage/waybillManage/components/components/Position.vue";
export default {
  name: "ApplicationForPayment",
  components: {
    accounting,
    paymentAction,
    payPassword,
    BatchWaybill,
    ColumnDrag,
    Position
  },
  data() {
    return {
      isHasSub: this.$store.state.user.party.companyType,
      shipment: this.$store.getters.shipment || { isPayPermission: 1 },
      showTable: true,
      columns: [
        {
          name: "承运主体",
          value: "branchCode",
          visible: true,
          minWidth: 150
        },
        {
          name: "纸质回单状态",
          value: "isReceiptReturn",
          visible: true,
          minWidth: 150
        },
        {
          name: "运输单号",
          value: "orderCode",
          visible: true,
          minWidth: 250
        },
        {
          name: "货源单号",
          value: "mainOrderNumber",
          visible: true,
          minWidth: 250
        },
        {
          name: "来源单号",
          value: "sourceOrderNumber",
          visible: true,
          minWidth: 200
        },
        {
          name: "项目名称",
          value: "projectName",
          visible: true,
          minWidth: 200
        },
        {
          name: "线路简称",
          value: "lineName",
          visible: true,
          minWidth: 200
        },
        {
          name: "经办人",
          value: "dfName",
          visible: true,
          minWidth: 200
        },
        {
          name: "托运人名称",
          value: "shipmentName",
          visible: true,
          minWidth: 260
        },
        {
          name: "托运人电话",
          value: "ordCreatedByPhone",
          visible: true,
          minWidth: 160
        },
        {
          name: "托运人类型",
          value: "shipmentStaffTypeStr",
          visible: true,
          minWidth: 160
        },
        {
          name: "托运人",
          value: "companyName",
          visible: true,
          minWidth: 160
        },
        {
          name: "结算类型",
          value: "isMonthlyOrder",
          visible: true,
          minWidth: 100
        },
        {
          name: "支付状态",
          value: "shipmentPayStatus",
          visible: true,
          minWidth: 200
        },
        {
          name: "失败原因",
          value: "shipmentPayFailReasons",
          visible: true,
          minWidth: 200
        },
        {
          name: "货物名称",
          value: "coalTypeName",
          visible: true,
          minWidth: 130
        },
        {
          name: "货物单价",
          value: "coalPrice",
          visible: true,
          minWidth: 200
        },
        {
          name: "运输要求",
          value: "coalName",
          visible: true,
          minWidth: 130
        },
        {
          name: "装货地址",
          value: "placeOfShipment",
          visible: true,
          minWidth: 450
        },
        {
          name: "实际操作装货地址",
          value: "loadPlace",
          visible: true,
          minWidth: 450
        },
        {
          name: "卸货地址",
          value: "placeOfReceipt",
          visible: true,
          minWidth: 450
        },
        {
          name: "实际操作卸货地址",
          value: "unloadPlace",
          visible: true,
          minWidth: 450
        },
        {
          name: "里程数(公里)",
          value: "distance",
          visible: true,
          minWidth: 200
        },
        {
          name: "车队名称",
          value: "teamName",
          visible: true,
          minWidth: 200
        },
        {
          name: "实际承运人姓名",
          value: "driverName",
          visible: true,
          minWidth: 130
        },
        {
          name: "实际承运人电话",
          value: "driverPhone",
          visible: true,
          minWidth: 130
        },
        {
          name: "车牌号",
          value: "vehicleLicense",
          visible: true,
          minWidth: 130
        },
        {
          name: "接单数量",
          value: "weight",
          visible: true,
          minWidth: 200
        },
        {
          name: "装货数量",
          value: "loadQuantity",
          visible: true,
          minWidth: 200
        },
        {
          name: "卸货数量",
          value: "unloadQuantity",
          visible: true,
          minWidth: 200
        },
        {
          name: "货物损耗",
          value: "wastage",
          visible: true,
          minWidth: 200
        },
        {
          name: "结算吨位",
          value: "settlementWeight",
          visible: true,
          minWidth: 200
        },
        {
          name: "最高价",
          value: "maxPrice",
          visible: true,
          minWidth: 200
        },
        {
          name: "托运人成交单价",
          value: "taxPrice",
          visible: true,
          minWidth: 200,
          isAdmin: true
        },
        {
          name: "托运人预估运费(元)",
          value: "taxFee",
          visible: true,
          minWidth: 200,
          isAdmin: true
        },
        {
          name: "到付款费(元)",
          value: "shipperDeliveryFee",
          visible: true,
          minWidth: 200
        },
        {
          name: "到付款服务费(元)",
          value: "taxPayFee",
          visible: true,
          minWidth: 200
        },
        {
          name: "托运人应付运费(元)",
          value: "shipmentDeliveryFeePractical",
          visible: true,
          minWidth: 200,
          isAdmin: true
        },
        {
          name: "实际承运人到付应收运费",
          value: "driverActualCash",
          visible: true,
          minWidth: 200
        },
        {
          name: "实际承运人承运单价",
          value: "realPrice",
          visible: true,
          minWidth: 200,
          isAdmin: true
        },
        {
          name: "实际承运人预估运费(元)",
          value: "deliveryFeeDeserved",
          visible: true,
          minWidth: 200,
          isAdmin: true
        },
        {
          name: "实际承运人应收运费(元)",
          value: "deliveryFeePractical",
          visible: true,
          minWidth: 200,
          isAdmin: true
        },
        {
          name: "实际承运人合计收款(元)",
          value: "deliveryCashFee",
          visible: true,
          minWidth: 200,
          isAdmin: true
        },
        {
          name: "其他费用(元)",
          value: "extraFee",
          visible: true,
          minWidth: 200
        },
        {
          name: "异常费用(元)",
          value: "abnormalFee",
          visible: true,
          minWidth: 200
        },
        {
          name: "接单时间",
          value: "gmtCreated",
          visible: true,
          minWidth: 420
        },
        {
          name: "截止装车时间",
          value: "lastLoadingTime",
          visible: true,
          minWidth: 420
        },
        {
          name: "装车时间",
          value: "fillTime",
          visible: true,
          minWidth: 420
        },
        {
          name: "截止卸车时间",
          value: "lastUnloadingTime",
          visible: true,
          minWidth: 420
        },
        {
          name: "卸车时间",
          value: "signTime",
          visible: true,
          minWidth: 420
        },
        {
          name: "核算时间",
          value: "settleTime",
          visible: true,
          minWidth: 420
        },
        {
          name: "最后操作时间",
          value: "gmtModified",
          visible: true,
          minWidth: 420
        },
        {
          name: "最后操作人",
          value: "modifiedByName",
          visible: true,
          minWidth: 130,
          isAdmin: true
        }
      ],
      columnSettingVisible: false,
      dialogVisiblePre: false,
      showPay: false,
      exportObj: {
        exportUrl: "/ntocc-tms-api/orderDetail/exportMakeMoney", //导出接口
        name: "托运人打款"
      },
      partyType: this.$store.getters.party.partyType,
      message: "",
      leitype: "",
      business: false,
      details: false,
      timer: "",
      code4OrderTrack: "",
      positoinInfo: {},
      positionFlag: false,
      reject: false,
      loading: false,
      makeMoney_search_button: false, //查询
      makeMoney_batchPayment_button: false, //批量打款
      makeMoney_detail_button: false, //详情
      makeMoney_reject_button: false, //驳回
      makeMoney_payment_button: false, //打款
      MakeMoney_update_button: false, // 更新支付状态
      tableData: [],
      parentData: {
        isMonthlyOrderOptions: []
      },
      parentMsg: "",
      acclist: [],
      options: [
        {
          value: "1",
          label: "已接单"
        },
        {
          value: "2",
          label: "已装货"
        },
        {
          value: "3",
          label: "已卸货"
        },
        {
          value: "4",
          label: "已结算"
        },
        {
          value: "5",
          label: "已打款"
        }
      ],
      shipmentOptions: [
        { label: "个体托运人", value: 0 },
        { label: "企业托运人", value: 1 }
      ],
      receiptOptions: [
        {
          value: "0",
          label: "未收取"
        },
        {
          value: "1",
          label: "已收取"
        },
        {
          value: "2",
          label: "已签收"
        }
      ],
      // 支付状态
      payOptions: [
        {
          label: "未支付",
          value: 0
        },
        {
          label: "处理中",
          value: 1
        },
        {
          label: "已支付",
          value: 2
        },
        {
          label: "已失败",
          value: 3
        }
      ],
      // 托运人支付
      payShipment: [
        {
          label: "未支付",
          value: 0
        },
        {
          label: "处理中",
          value: 1
        },
        {
          label: "已失败",
          value: 2
        }
      ],
      value: "",
      listQuery: {
        gmtCreatedRange: "",
        lastLoadingTimeRange: "",
        fillTimeRange: "",
        lastUnloadingTimeRange: "",
        signTimeRange: "",
        settleTimeRange: "",
        gmtModifiedRange: "",
        pageNum: 1,
        pageSize: 20,
        total: 0,
        isSettle: 1,
        status: 4,
        notEqualApplyStatus: 1, //不等于此申请打款状态
        shipType: "shipPay" //支付状态
      },
      sumObject: {},
      // 机构列表
      branchList: this.$store.state.components.branchList,
      actionFlag: false,
      // 是否admin
      isAdmin: false,
      isShipment: false,
      isShipmentOrAdmin: false,
      isDriverOrAdmin: false,
      payInfo: null,
      // 勾选行的托运人应付运费汇总
      selectedShipmentDeliveryFeePracticalSum: 0,
      selectedShipmentServiceFeePracticalSum: 0,
      selectedShipmentDriverActualCashSum: 0,
      prelist: null,
      batchInputDialogVisible: false
    };
  },
  computed: {
    isSub() {
      return this.$route.path.includes("sub_MakeMoney");
    },
    toolbarId() {
      const path = (this.$route.path || "").replace(/\//g, "_");
      return `toolbar_applicationForPayment${path ? "_" + path : ""}`;
    },
    tableKey() {
      return `applicationForPayment_table_${(
        this.$route.fullPath || ""
      ).replace(/[/?=&]/g, "_")}`;
    }
  },
  watch: {
    "$route.fullPath"(newVal, oldVal) {
      if (newVal === oldVal) return;
      this.listQuery = {
        gmtCreatedRange: "",
        lastLoadingTimeRange: "",
        fillTimeRange: "",
        lastUnloadingTimeRange: "",
        signTimeRange: "",
        settleTimeRange: "",
        gmtModifiedRange: "",
        pageNum: 1,
        pageSize: 20,
        total: 0,
        isSettle: 1,
        status: 4,
        notEqualApplyStatus: 1, //不等于此申请打款状态
        shipType: "shipPay", //支付状态
        returnPayStatus: 0
      };
      this.selectedShipmentDeliveryFeePracticalSum = 0;
      this.selectedShipmentServiceFeePracticalSum = 0;
      this.selectedShipmentDriverActualCashSum = 0;
      this.$nextTick(() => {
        const table = this.$refs.xTable;
        if (!table) return;
        if (table.clearSort) table.clearSort();
        if (table.clearCheckboxRow) table.clearCheckboxRow();
      });
      this.findList();
    }
  },
  created() {
    let columns = localStorage.getItem("applicationForPaymentColumn") || "";
    if (columns) {
      this.columns = JSON.parse(columns);
    }
    const partyType = this.$store.getters.party.partyType;
    const isAdmin =
      partyType == "SUPER_ADMIN" ||
      partyType == "PLAT_ADMIN" ||
      partyType == "STAFF";
    this.isAdmin = isAdmin;
    this.isShipment =
      partyType == "SHIPMENT" || partyType == "SHIPMENT_COMPANY";
    this.isShipmentOrAdmin =
      partyType == "SHIPMENT" || partyType == "SHIPMENT_COMPANY" || isAdmin;
    this.isDriverOrAdmin =
      partyType == "DRIVER" || partyType == "DRIVER_LEADER" || isAdmin;
    this.parentData.isMonthlyOrderOptions = [
      { label: "次结", value: 0 },
      { label: "月结", value: 1 }
    ];
    this.findList();
    this.makeMoney_search_button = getLimit("makeMoney_search_button");
    this.makeMoney_batchPayment_button = getLimit(
      "makeMoney_batchPayment_button"
    );
    this.makeMoney_detail_button = getLimit("makeMoney_detail_button");
    this.makeMoney_reject_button = getLimit("makeMoney_reject_button");
    this.makeMoney_payment_button = getLimit("makeMoney_payment_button");
    this.MakeMoney_update_button = getLimit("MakeMoney_update_button");
  },
  // async activated() {
  //   await this.findList();
  // },
  methods: {
    applyColumnSettings(payload) {
      console.log("更新返回===========", payload);
      this.columns = payload.columns;
      localStorage.setItem(
        "applicationForPaymentColumn",
        JSON.stringify(payload.columns)
      );
      this.columnSettingVisible = false;
      this.showTable = false;
      this.$nextTick(() => {
        this.showTable = true;
      });
      this.$forceUpdate();
    },
    formatterSwitch(scope) {
      let valueCell = scope.row[scope.column.property];
      if (scope.column.property === "shipmentDeliveryFeePractical") {
        return scope.row.shipmentDeliveryFeePractical || scope.row.taxFee;
      }
      // if (scope.column.property === "price") {
      //   return scope.row.price + scope.row.isTrunkName;
      // }
      if (scope.column.property === "deliveryFeePractical") {
        return scope.row.deliveryFeePractical || scope.row.deliveryFeeDeserved;
      }
      if (scope.column.property === "branchCode") {
        const item = this.branchList.find(item => item.code === valueCell);
        return item ? item.groupName : "";
      }
      if (scope.column.property === "isCancel") {
        const item = this.cancelOptions.find(item => item.value === valueCell);
        return item ? item.label : "";
      }
      if (scope.column.property === "isMonthlyOrder") {
        // this.formatterField(valueCell, "isMonthlyOrder");
        const item = this.parentData[`isMonthlyOrderOptions`].find(
          item => item.value === valueCell
        );
        return item ? item.label : "";
      }
      if (scope.column.property === "isTransfer") {
        return valueCell > 0 ? "是" : "否";
      }
      if (scope.column.property === "status") {
        const item = this.statusOptions.find(
          item1 => item1.value === valueCell
        );
        return item ? item.label : "";
      }

      if (scope.column.property === "isUnloadingConfirm") {
        let data = valueCell == 0;
        return data ? "未签收" : "已签收";
      }

      if (scope.column.property === "payStatus") {
        const item = this.payOptions.find(item => item.value === valueCell);
        return item ? item.label : "";
      }

      if (scope.column.property === "isMonthlyOrder") {
        // this.formatterField(valueCell, "isMonthlyOrder");
        const item = this.parentData[`isMonthlyOrderOptions`].find(
          item => item.value === valueCell
        );
        return item ? item.label : "";
      }
      if (scope.column.property === "reportMark") {
        return valueCell > 0 ? "是" : "否";
      }
      if (scope.column.property === "prePay") {
        return Number(valueCell);
      }

      if (scope.column.property === "shipmentPayStatus") {
        const item = this.payShipment.find(item => item.value === valueCell);
        return item ? item.label : "";
      }

      if (scope.column.property === "isReceiptReturn") {
        switch (valueCell) {
          case "0":
            return "未收取";
          case "1":
            return "已收取";
          case "2":
            return "已签收";
          default:
            break;
        }
      }
      return valueCell;
    },
    copyText(text) {
      if (!text) return;
      const textarea = document.createElement("textarea");
      textarea.value = text;
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand("copy");
      document.body.removeChild(textarea);
      this.$message({
        message: "复制成功",
        type: "success",
        duration: 1500
      });
    },
    confirmBatchInput(parsedOrderCodes) {
      if (parsedOrderCodes.length > 300) {
        this.$message.warning("运单号数量不能超过300个");
        return;
      }
      this.listQuery.orderCode = parsedOrderCodes.join(",");
      this.batchInputDialogVisible = false;
      this.funcFilter();
    },
    copyPre() {
      // 复制
      const textarea = document.createElement("textarea");
      textarea.value = this.prelist;
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand("copy");
      document.body.removeChild(textarea);
      this.$message.success("复制成功");
      this.dialogVisiblePre = false;
    },
    funcReject(codes) {
      this.$confirm("确认驳回？").then(_ => {
        const rLoading = this.openLoading();
        financeReject({ codes }).then(response => {
          rLoading.close();
          this.$message({ message: response.msg, type: "success" });
          this.findList();
        });
      });
    },
    handleClick(c) {
      this.details = true;
      this.$refs.detailRef.Getdetails(c);
    },
    positionFunc(row, form) {
      const source = form || (row && typeof row === "object" ? row : {}) || {};
      this.positoinInfo = {
        vehicleLicense: source.vehicleLicense || source.licenseNumber || "",
        fillTime: source.fillTime || "",
        signTime: source.signTime || ""
      };
      this.timer = new Date().getTime();
      this.code4OrderTrack = row && typeof row === "object" ? row.code : row;
      this.positionFlag = true;
    },
    closePositionFunc() {
      this.$refs.positionRef.closeModal();
    },
    fatherSubmitFunc(modelFlag) {
      switch (modelFlag) {
        case "position":
          this.positionFlag = false;
          break;
        default:
      }
      this.findList();
    },
    fatherCancelFunc(modelFlag) {
      switch (modelFlag) {
        case "position":
          this.positionFlag = false;
          break;
        default:
      }
    },
    businessClick(codes, paymentType, shipperPhone) {
      console.log("打款=========", codes, paymentType, shipperPhone);
      if (paymentType == "arpa") {
        this.realpay(codes);
        return;
      }

      let data = {
        codes: codes
      };
      this.preApplicationForPayment(codes, paymentType, shipperPhone);
      return;
      //查询是否存在支付密码
      request({
        url: `/ntocc-basic-api/pay/isexist`,
        method: "get",
        params: data
      }).then(res => {
        if (res.status == 0 && res.data.isHave == "1") {
          this.payInfo = { codes, paymentType, shipperPhone };
          this.showPay = true;
          rLoading.close();
          return;
        } else {
          rLoading.close();
          this.$confirm("您还未设置支付密码，请前往设置", "提示", {
            confirmButtonText: "去设置",
            cancelButtonText: "取消",
            type: "warning"
          })
            .then(() => {
              this.$router.push({
                path: "/systemManage/payPassword/addPassword"
              });
            })
            .catch(() => {});
        }
      });
    },
    completePsw() {
      // this.showPay = false;
      // const { codes, paymentType, shipperPhone } = this.payInfo;
      // this.preApplicationForPayment(codes, paymentType, shipperPhone);
    },
    preApplicationForPayment(codes, paymentType, shipperPhone) {
      let data = {
        codes: codes
      };
      // 判断支付方式
      const rLoading = this.openLoading();
      request({
        url: `/ntocc-tms-api/orderDetail/preApplicationForPayment`,
        method: "post",
        params: data
      })
        .then(response => {
          if (response.status == 0) {
            rLoading.close();
            this.actionFlag = true;
            this.$nextTick(() => {
              this.$refs.actionRef.init(response, shipperPhone, codes);
            });
          }
        })
        .catch(err => {
          let str = JSON.stringify(err);
          const parts = str.split("prelist:");
          if (parts.length) {
            this.prelist = parts[1] || "";
            // 将引号替换为空
            this.prelist = this.prelist.replace(/"/g, "");
            console.log("prelist", this.prelist);
            if (this.prelist) {
              this.dialogVisiblePre = true;
            }
          }
          // 弹窗提示，可复制
        });
      rLoading.close();
    },
    getSelectEvent() {
      const checkedRowArray = this.$refs.xTable.getCheckboxRecords();
      let branchCode = checkedRowArray[0].branchCode;
      let shipmentCode = checkedRowArray[0].shipmentCode;
      let paymentType = checkedRowArray[0].paymentType;
      if (checkedRowArray.length === 0) {
        this.$message({ message: "请选择订单", type: "warning" });
      } else if (checkedRowArray.length > 100) {
        this.$message({ message: "批量处理最多100条数据", type: "warning" });
      } else {
        let arrcarcode = [];
        for (let subItem of checkedRowArray) {
          if (paymentType == "arpa" && subItem.branchCode != branchCode) {
            this.$message.warning("请选择同一机构");
            return false;
          }
          if (paymentType == "arpa" && subItem.shipmentCode != shipmentCode) {
            this.$message.warning("请选择同一托运人");
            return false;
          }
          arrcarcode.push(subItem.code);
        }
        let codes = arrcarcode.join(",");
        if (paymentType == "arpa") {
          this.realpay(codes);
        } else {
          this.businessClick(codes);
        }
      }
    },
    updateSelectedFeeSum() {
      const records = this.$refs.xTable
        ? this.$refs.xTable.getCheckboxRecords()
        : [];
      this.selectedShipmentDeliveryFeePracticalSum = this.$XEUtils
        ? this.$XEUtils.sum(records, "shipperDeliveryFee")
        : records.reduce(
            (acc, r) => acc + Number(r.shipperDeliveryFee || 0),
            0
          );

      this.selectedShipmentServiceFeePracticalSum = this.$XEUtils
        ? this.$XEUtils.sum(records, "taxPayFee")
        : records.reduce((acc, r) => acc + Number(r.taxPayFee || 0), 0);
      this.selectedShipmentDriverActualCashSum = this.$XEUtils
        ? this.$XEUtils.sum(records, "driverActualCash")
        : records.reduce((acc, r) => acc + Number(r.driverActualCash || 0), 0);
    },

    // 确认提示
    realpay(codes) {
      this.$confirm("确认要打款吗？")
        .then(_ => {
          this.payclick(codes);
        })
        .catch(_ => {});
    },
    async payclick(codes) {
      const rLoading = this.openLoading();
      let response = await shipperPaymentSure({ codes });
      rLoading.close();
      this.$message.success(response.msg);
      this.findList();
    },
    getRejectEvent() {
      const selectRecords = this.$refs.xTable.getSelectRecords();
      if (selectRecords.length === 0) {
        this.$message({ message: "请选择订单", type: "warning" });
      } else if (selectRecords.length > 20) {
        this.$message({ message: "批量处理最多20条数据", type: "warning" });
      } else {
        const arrcarcode = selectRecords.map(item => {
          return item.code;
        });
        let codes = arrcarcode.join(",");
        this.funcReject(codes);
      }
    },
    updataShipperPaymentResult(item) {
      const selectRecords = item
        ? [item]
        : this.$refs.xTable.getSelectRecords();
      if (selectRecords.length === 0) {
        this.$message({ message: "请选择订单", type: "warning" });
      } else if (selectRecords.length > 20) {
        this.$message({ message: "批量处理最多20条数据", type: "warning" });
      } else {
        const rLoading = this.openLoading();
        const arrcarcode = selectRecords.map(item => {
          return item.code;
        });
        let codes = arrcarcode.join(",");
        if (codes) {
          queryShipperPaymentResult({ codes }).then(res => {
            this.$message({ message: res.msg, type: "success" });
            this.findList();
            rLoading.close();
          });
        } else {
          this.$message({
            type: "warning",
            message: "暂无可更新的运单"
          });
        }
      }
    },
    receive() {
      this.actionFlag = false;
      this.findList();
    },
    findList() {
      this.loading = true;
      return new Promise(resolve => {
        // 子公司运单管理
        let api = this.$route.path.includes("sub_MakeMoney")
          ? querySubList
          : orderDetailListAll;
        api(this.listQuery).then(response => {
          this.tableData = response.data.records;
          this.tableData.forEach(item => {
            item.taxPrice = item.taxPrice + item.isTrunkName;
            item.price = item.price + item.isTrunkName;
            item.realPrice = item.realPrice + item.isTrunkName;
            item.coalPrice = item.coalPrice + "元/" + item.coalUnitName;
            item.maxPrice = item.maxPrice + item.isTrunkName;
            item.weight = item.weight + item.coalUnitName;
            item.loadQuantity = item.loadQuantity + item.coalUnitName;
            item.unloadQuantity = item.unloadQuantity + item.coalUnitName;
          });
          this.listQuery.total = response.data.total;
          this.sumObject = response.data.sumObject;
          this.loading = false;
          resolve();
        });
      });
    },
    // 翻译机构
    formatterBranch({ cellValue }) {
      const item = this.branchList.find(item => item.code === cellValue);
      return item ? item.groupName : "";
    },
    //状态翻译
    formatterReceiptStatus({ cellValue }) {
      switch (cellValue) {
        case "0":
          return "未收取";
        case "1":
          return "已收取";
        case "2":
          return "已签收";
        default:
          break;
      }
    },
    // 支付状态翻译
    formatterPayStatus({ cellValue }) {
      const item = this.payOptions.find(item => item.value === cellValue);
      return item ? item.label : "";
    },
    // 托运人支付状态翻译
    formatterApplyStatus({ cellValue }) {
      const item = this.payShipment.find(item => item.value === cellValue);
      return item ? item.label : "";
    },
    headerCellClassName({ column, columnIndex }) {
      if (column.property === "name") {
        return "col-blue";
      }
    },
    cellClassName({ row, rowIndex, column, columnIndex }) {
      if (column.property === "status") {
        switch (row.status) {
          case 0:
            return "col-red";
          case 1:
            return "col-green";
          case 2:
            return "col-orange";
          case 3:
            return "col-red";
          case 4:
            return "col-green";
          case 5:
            return "col-orange";

          default:
            break;
        }
      }
    },
    formatterField({ cellValue }, prefix) {
      const item = this.parentData[`${prefix}Options`].find(
        cell => cell.value === cellValue
      );
      return item ? item.label : "";
    },
    formatterStatus({ cellValue }) {
      switch (cellValue) {
        case 1:
          return "已接单";
        case 2:
          return "已装货";
        case 3:
          return "已卸货";
        case 4:
          return "已结算";
        case 5:
          return "已打款";

        default:
          break;
      }
    },
    footerMethod({ columns, data }) {
      return [
        columns.map((column, columnIndex) => {
          if (columnIndex === 0) {
            return "合计";
          }
          if (
            [
              "shipmentActualFreight",
              "payTaxAmount",
              "driverActualFreight",
              "shipmentActualCash",
              "shipmentDeliveryFeePractical",
              "platformPrepayment",
              "driverActualCash",
              "extraFee",
              "abnormalFee",
              "payOil",
              "payAmount",
              "allotOil"
            ].includes(column.property)
          ) {
            return this.$XEUtils.sum(data, column.property);
          }
          if (column.property === "shipperDeliveryFee") {
            return this.sumObject.shipperDeliveryFee;
          }
          if (column.property === "deliveryFeePractical") {
            return this.sumObject.deliveryFeePractical;
          }
          if (column.property === "deliveryCashFee") {
            return this.sumObject.deliveryCashFee;
          }
          if (column.property === "taxFee") {
            return this.sumObject.taxFee;
          }
          if (column.property === "taxPayFee") {
            return this.sumObject.taxPayFee;
          }
          if (column.property === "distance") {
            return this.sumObject.distance;
          }
          if (column.property === "deliveryOilFee") {
            return this.sumObject.deliveryOilFee;
          }
          if (column.property === "deliveryFeeDeserved") {
            return this.sumObject.deliveryFeeDeserved;
          }
          if (column.property === "weight") {
            return (
              this.sumObject.ton +
              "吨//" +
              this.sumObject.cubicMeter +
              "方//" +
              this.sumObject.pieces +
              "件"
            );
          }
          if (column.property === "loadQuantity") {
            return (
              this.sumObject.loadQuantityTon +
              "吨//" +
              this.sumObject.loadQuantityCubicMeter +
              "方//" +
              this.sumObject.loadQuantityPieces +
              "件"
            );
          }
          if (column.property === "wastage") {
            return (
              this.sumObject.wastageTon +
              "吨//" +
              this.sumObject.wastageCubicMeter +
              "方//" +
              this.sumObject.wastagePieces +
              "件"
            );
          }

          if (column.property === "unloadQuantity") {
            return (
              this.sumObject.unloadQuantityTon +
              "吨//" +
              this.sumObject.unloadQuantityCubicMeter +
              "方//" +
              this.sumObject.unloadQuantityPieces +
              "件"
            );
          }
          if (column.property === "settlementWeight") {
            return (
              this.sumObject.settlementWeightTon +
              "吨//" +
              this.sumObject.settlementWeightCubicMeter +
              "方//" +
              this.sumObject.settlementWeightPieces +
              "件"
            );
          }
          return "-";
        })
      ];
    }
  }
};
</script>
<style>
.checkbox-table.vxe-table .vxe-body--row.row-checked {
  background-color: #fbf8ec;
}
.vxe-footer--row .col-blue {
  background-color: rgb(233, 20, 20);
  color: #fff;
}
.vxe-footer--row .col-red {
  background-color: rgb(32, 11, 219);
  color: #fff;
}
.mytable-footer .vxe-body--row.row-green {
  background-color: #187;
  color: #2db7f5;
}
.mytable-footer .vxe-header--column.col-blue {
  background-color: #2db7f5;
  color: #fff;
}
.mytable-footer .vxe-body--column.col-red {
  color: #f00;
}
.mytable-footer .vxe-body--column.col-orange {
  color: #f60;
}
.mytable-footer .vxe-body--column.col-green {
  color: rgb(29, 47, 202);
}
</style>

<style scoped>
.oeder_num_box {
  position: relative;
  display: flex;
  align-items: center;
}
.abnormal_text {
  border-radius: 20px;
  color: red;
  border: 1px solid red;
  text-align: center;
  padding: 0px 5px;
  margin-left: 7px;
}
.yu_text {
  border-radius: 20px;
  color: green;
  border: 1px solid green;
  text-align: center;
  padding: 0px 5px;
  margin-left: 7px;
}
.icon_yu {
  position: absolute;
  top: 0px;
  right: 0px;
  width: 20px;
  height: 20px;
}
::v-deep .vxe-table--footer-wrapper.body--wrapper::-webkit-scrollbar {
  -webkit-appearance: none; /* 禁用默认样式 */
  height: 12px !important; /* 设置滚动条高度（常驻显示） */
  background-color: #f1f1f1; /* 轨道背景色 */
}
::v-deep .vxe-table--footer-wrapper.body--wrapper::-webkit-scrollbar-thumb {
  background-color: #c1c1c1 !important; /* 滑块颜色 */
  border-radius: 5px !important; /* 滑块圆角 */
}
/* 针对微信浏览器定制滚动条 */
::v-deep
  .vxe-table:not(.is--empty).show--foot.scroll--x
  .vxe-table--body-wrapper::-webkit-scrollbar {
  -webkit-appearance: none; /* 禁用默认样式 */
  height: 12px !important; /* 设置滚动条高度（常驻显示） */
  background-color: #f1f1f1; /* 轨道背景色 */
}

::v-deep
  .vxe-table:not(.is--empty).show--foot.scroll--x
  .vxe-table--body-wrapper::-webkit-scrollbar-thumb {
  background-color: #c1c1c1 !important; /* 滑块颜色 */
  border-radius: 5px !important; /* 滑块圆角 */
}
</style>
